/**
 * Categorical series colours, assigned in this fixed order (never cycled).
 * The first three pass the colour-vision checks as a set on a white surface;
 * slot 3 is below 3:1 contrast, so every chart ships with a table view.
 */
export const SERIES_COLORS = ["#2a78d6", "#eb6834", "#1baf7a"] as const;

/** A clean y-axis maximum and tick step (1, 2, 5 × 10ⁿ). */
export function niceScale(max: number, ticks = 4): { top: number; step: number } {
  if (max <= 0) return { top: ticks, step: 1 };
  const raw = max / ticks;
  const magnitude = 10 ** Math.floor(Math.log10(raw));
  const step = [1, 2, 5, 10].map((m) => m * magnitude).find((s) => s >= raw) ?? raw;
  const rounded = Math.max(1, step);
  return { top: Math.ceil(max / rounded) * rounded, step: rounded };
}
